import React, { Component } from "react";
// import { render } from "react-dom";
import {Link} from "react-router-dom";
import DatePicker from 'react-date-picker';
import Select from "react-select";

import './NewOrder.scss';
import MyContext from '../MyContext.jsx';
import {epochToDate} from '../../assets/js/handy.mjs';
import BillingDetails from "./BIllingDetails";

const DRAFT_KEY = 'alsafas_neworder_draft';
const cacheKey = "alsafas_emak_customers_cache";
const cacheExpiryKey = "alsafas_emak_customers_cache_expiry";
const now = Date.now();
const oneDay = 7 * 24 * 60 * 60 * 1000;

class NewOrder extends Component {
  constructor(props) {
    super(props);
    // this.locationSelect = React.createRef();

    var today = new Date();
    var tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    this.state = {
      salesorder_id : '',
      customers : [],
      customer : {},
      order_date : today,
      delivery_date : tomorrow,
      remarks : '',
      billing_address : '',
      billing_contact_no : '',
      products : [],
      rows: [],
      entryProduct: {},
      entryUnits: [],
      entryUnit: {},
      entryQty: '',
      entryUnitPrice: '',
      grand_total : '',
      schedule : false,
      action: '',
      billingCollapsed: false,
      showDraftPopup: false,
      draftToRestore: null,
      activeTab: 'details',
    }
    this.formChange = this.formChange.bind(this);
    this.paymentTypeChange = this.paymentTypeChange.bind(this);
    this.deliveryTypeChange = this.deliveryTypeChange.bind(this);
    this.goBackButton = this.goBackButton.bind(this);
    this.designIssueFix = this.designIssueFix.bind(this);
    this.billingDetailsRef = React.createRef();
    this.handleDraftRestore = this.handleDraftRestore.bind(this);
    this.handleDraftStartNew = this.handleDraftStartNew.bind(this);
    this.clearAllState = this.clearAllState.bind(this);
    this.isSubmitting = false;
    this.productRowRefs = [];
    this.entryQtyInputRef = React.createRef();
    this.getCustomers = this.getCustomers.bind(this);
    this.minimizeProduct = this.minimizeProduct.bind(this);
    this.handleFormKey = this.handleFormKey.bind(this);
    this.openProductsOnFocus = this.openProductsOnFocus.bind(this);
    this.expandRowOnFocus = this.expandRowOnFocus.bind(this);
  }

  componentDidMount(){   
    $(".react-date-picker__inputGroup input").attr("readonly","true");

    const draft = localStorage.getItem(DRAFT_KEY);

    const {pathname} = this.props.location;

    if(pathname === "/salesorders/new") {
      const cachedCustomers = localStorage.getItem(cacheKey);
      const cacheExpiry = localStorage.getItem(cacheExpiryKey);
      if (cachedCustomers && cacheExpiry && now < parseInt(cacheExpiry, 10)) {
        const return_data = JSON.parse(cachedCustomers);
        let customer_id;
        const { location } = this.props;
        if (location.state && location.state.customer_id) {
          this.setState({ schedule: true });
          customer_id = location.state.customer_id;
        }
        let option = null;
        this.setState({
          customers : return_data.customers,
          products : return_data.products,
          // rows : [{
          //   product : {},
          //   unit_price : '',
          //   qty : '',
          //   units : [],
          //   unit: {},
          //   total : '',
          // }]
        }, () => {
          $(".new_salesorder_container").css("visibility","visible");
        });
        if(customer_id && return_data.customers){
          option = return_data.customers.find(item => item.value === customer_id);
          if(option == null ){
            this.props.history.push("/dayplan/details/edit/"+this.props.location.state.schedule_id, { from : "salesorder", purposeOfVisit : this.props.location.state.purposeOfVisit });
          }
          this.setState({ customer : option, customers : return_data.customers });
          this.customerChange(option);
        }
        if (draft) {
          this.setState({ showDraftPopup: true, draftToRestore: JSON.parse(draft) });
        }
        this.context.loading(0);
        this.designIssueFix();
        return;
      }
      const url = `${process.env.REACT_APP_SSS}/api/getCustomers`;
      this.context.loading(1);
      let customer_id;
      const { location } = this.props;
      // console.log(location);
      if (location.state && location.state.customer_id) {
        this.setState({
          schedule: true,
        });
        customer_id = location.state.customer_id;

      }
      let option = null;
      var obj_this = this;
      $.ajax({
        url : url,
        data : {
          sid : this.context.user_details.sid
        },
        type : "POST"
      }).done(function(return_data){
        // console.log(return_data);
        if(return_data.status == "success"){
          localStorage.setItem(cacheKey, JSON.stringify(return_data));
          localStorage.setItem(cacheExpiryKey, (now + oneDay).toString());
          obj_this.setState({
            customers : return_data.customers,
            products : return_data.products,
            rows: []
          },() => {
            $(".new_salesorder_container").css("visibility","visible");
          });
          if(customer_id && return_data.customers){
            option = return_data.customers.find(item => item.value === customer_id);
            if(option == null ){
              obj_this.props.history.push("/dayplan/details/edit/"+obj_this.props.location.state.schedule_id, { from : "salesorder", purposeOfVisit : obj_this.props.location.state.purposeOfVisit });
            }
            obj_this.setState({
              customer : option,
            })
            obj_this.customerChange(option);
          }
          obj_this.context.loading(0);
        }else{
          obj_this.context.loading(0);
          obj_this.props.history.replace("/");
        }
      }).fail(function(){
        alert("Network error");
      });
    }else{
      const salesorder_id = this.props.match.params.sid;
      const url = `${process.env.REACT_APP_SSS}/api/editSalesorder`;
      this.context.loading(1);
      var obj_this = this;
      $.ajax({
        url : url,
        data : {
          sid : this.context.user_details.sid,
          salesorder_id : salesorder_id
        },
        type : "POST"
      }).done(function(return_data){
        // console.log(return_data);
        // return;
        if(return_data.status == "success"){
          localStorage.removeItem(DRAFT_KEY);
          var state_object = return_data.state_object;
          state_object.order_date = epochToDate(state_object.order_date);
          state_object.delivery_date = epochToDate(state_object.delivery_date);
          // state_object.products = state_object.products;
          // state_object.clone_address = false;
          const cachedCustomers = localStorage.getItem(cacheKey);
          const cacheExpiry = localStorage.getItem(cacheExpiryKey);
          if (cachedCustomers && cacheExpiry && now < parseInt(cacheExpiry, 10)) {
            const return_data = JSON.parse(cachedCustomers);
            obj_this.setState({
              products: return_data.products,
            });
          }
          obj_this.setState({
            ...state_object,
            entryProduct: {},
            entryUnits: [],
            entryUnit: {},
            entryQty: '',
            entryUnitPrice: ''
          },() => {
            // obj_this.minimizeProduct();
            $(".new_salesorder_container").css("visibility","visible");
            obj_this.find_total(0);
          });

          obj_this.context.loading(0);
          // console.log(obj_this.state);

        }else{
          obj_this.context.loading(0);
          obj_this.props.history.replace("/");
        }
      }).fail(function(){
        alert("Network error");
      });
    }      
    this.designIssueFix();
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.state.showDraftPopup && !this.state.salesorder_id && !this.isSubmitting) {
      const { customers, products, showDraftPopup, draftToRestore, ...draftState } = this.state;
      try {
        localStorage.setItem(DRAFT_KEY, JSON.stringify(draftState));
      } catch (e) {}
    }
  }
  getCustomers() {
    const url = `${process.env.REACT_APP_SSS}/api/getCustomers`;
    this.context.loading(1);
   
    let option = null;
    var obj_this = this;
    $.ajax({
      url: url,
      data: {
        sid: this.context.user_details.sid
      },
      type: "POST"
    }).done(function (return_data) {
      // console.log(return_data);
      if (return_data.status == "success") {
        localStorage.setItem(cacheKey, JSON.stringify(return_data));
        localStorage.setItem(cacheExpiryKey, (now + oneDay).toString());
        obj_this.setState({
          products: return_data.products,
        });
        obj_this.context.loading(0);
      } else {
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
    }).fail(function () {
      alert("Network error");
    });
  }

  minimizeProduct() {
    setTimeout(() => {
      const $rows = $(".products_container .single_product_container");
      $rows.find(".minimize_button").trigger("click");
    }, 100);
  }

  handleDraftRestore() {
    const { draftToRestore } = this.state;
    this.setState({ ...draftToRestore, showDraftPopup: false, draftToRestore: null });
  }

  handleDraftStartNew() {
    localStorage.removeItem(DRAFT_KEY);
    this.setState({ showDraftPopup: false, draftToRestore: null });
    this.clearAllState();
  }


  designIssueFix() {
    $(".new_salesorder_container").css("visibility", "visible");

    let overflowTimeout;

    $(document).on("click.minToggle", ".products_container .maximize_button", function () {
      const elem = $(this).closest(".single_product_container");
      elem.find(".qty_unit_price_container").css("display", "none");
      if (typeof elem.heightAuto === "function") {
        elem.heightAuto().find(".minimize_button").css("display", "block");
      } else {
        elem.css("height", "auto").find(".minimize_button").css("display", "block");
      }
      $(this).css("display", "none");
      clearTimeout(overflowTimeout);
      overflowTimeout = setTimeout(function () {
        elem.css("overflow", "");
      }, 500);
    });

    $(document).on("click.minToggle", ".products_container .minimize_button", function () {
      const elem = $(this).closest(".single_product_container");
      elem.find(".qty_unit_price_container").css("display", "grid");
      clearTimeout(overflowTimeout);
      const original_height = elem.height();
      elem.height(original_height);
      setTimeout(function () {
        elem.css({ height: "46px", overflow: "hidden" })
          .find(".maximize_button").css("display", "block");
      }, 1);
      $(this).css("display", "none");
    });
  }
  
  // Prevent Enter/Tab from moving focus or submitting (covers soft keyboard Next/Done)
  handleFormKey(e) {
    const key = e.key != null ? e.key : e.keyCode;
    const isEnter = key === 'Enter' || key === 13;
    const isTab = key === 'Tab' || key === 9;
    if (!(isEnter || isTab)) return;
    const target = e.target;
    const tagName = (target && target.tagName) ? target.tagName.toUpperCase() : '';
    const isTextArea = tagName === 'TEXTAREA';
    const isButtonLike = tagName === 'BUTTON'
      || (target && target.getAttribute && target.getAttribute('role') === 'button')
      || (typeof target.closest === 'function' && !!target.closest('.tab_nav'));
    const isInReactSelect = typeof target.closest === 'function'
      && (target.closest('[class*="react-select"]') || target.closest('[class*="react-select__"]'));
    // Allow newlines in textareas only; block everywhere else
    // Also allow Enter on buttons/tabs and inside react-select menus/controls
    if (!isTextArea && !isButtonLike && !isInReactSelect) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
  }

  // Ensure the Products tab is visible when focusing product entry fields
  openProductsOnFocus() {
    if (this.state.activeTab !== 'products') {
      this.setActiveTab('products');
    }
  }

  // Expand the product row if an input inside it gains focus
  expandRowOnFocus(e) {
    try {
      const $container = $(e.target).closest('.single_product_container');
      if ($container && $container.length) {
        const $maxBtn = $container.find('.maximize_button');
        if ($maxBtn && $maxBtn.is(':visible')) {
          $maxBtn.trigger('click');
        }
      }
    } catch (_) {}
  }
  clearAllState(){
    this.setState({
      salesorder_id : '',
      // customers : [],
      customer : {},
      delivery_type : 256,
      payment_type : 132,
      remarks : '',
      billing_address : '',
      billing_contact_no : '',
      // delivery_address : '',
      // clone_address : false,
      // delivery_contact_no : '',
      // delivery_location : {},
      rows: [],
      entryProduct: {},
      entryUnits: [],
      entryUnit: {},
      entryQty: '',
      entryUnitPrice: '',
      grand_total : ''
    });
    localStorage.removeItem(DRAFT_KEY);
  }
  toggleBillingCollapse = () => {
    this.setState((prev) => ({ billingCollapsed: !prev.billingCollapsed }));
  };
  
  closeBilling = () => {
    this.setState({
      billingCollapsed: true
    });
  }

  setActiveTab = (tab) => {
    if(tab === "products")
      this.minimizeProduct();
    this.setState({ activeTab: tab });
  }

  customerChange(option){
    // console.log(option);
    var obj_this = this;
    if(obj_this.state.rows.length>=1 && !jQuery.isEmptyObject(obj_this.state.rows[0].product) ){
      if(!confirm("You will lose all added product data")){
        return
      }
      this.setState({
        remarks : '',
        billing_address : '',
        billing_contact_no : '',
        // delivery_address : '',
        // clone_address : false,
        // delivery_contact_no : '',
        // delivery_location : {},
        rows: [{
          product : {},
          qty : '',
          unit_price : '',
          units : [],
          unit: {},
          total : '',
        }],
        grand_total : ''
      });
    }
    obj_this.setState({
      customer : option,
      billing_address : option.address,
      billing_contact_no : option.tel_o??'',
      // delivery_address : '',
      // delivery_contact_no : '',
      // delivery_location : option.delivery_location??null
    }); 
  
  }

  paymentTypeChange(e){
    this.setState({
      payment_type : e.target.value
    }); 
  }

  deliveryTypeChange(e){
    this.setState({
      delivery_type : e.target.value
    }); 
  }
  
  formChange(e){
    this.setState({
      [e.target.name] : e.target.value
    });
  }
  onOrderDateChange(value){
    // console.log(value);
    this.setState({order_date : value});
  }

  onDeliveryDateChange(value){
    // alert(value);
    this.setState({delivery_date : value});
  }

  locationChange(option){
    this.setState({delivery_location : option})
  }

  productChange(option,idx){
    // console.log(option);
    if(!this.state.customer.value){
      alert('Please select Customer first');
      return
    }
    $(".single_product_container").css('background-color','');
    var obj_this = this;
    // console.log(option);
    if(!option.units){
      alert("No units available for this product");
      return;
    }
    if (option.base_price && option.base_price.total == null || (option.units && option.units.total==0.0)) {
      alert('Please set MRP in Product Master');
      obj_this.context.loading(0)
      return;
    }
  const rows = [...this.state.rows];
    // var item = rows.filter(item => item.product.label == option.label);
    // if(item.length){
    //   alert(item[0].product.label+" already added.");
    //   // rows.splice(-1,1);
    //   // this.setState({
    //   //     rows
    //   //   });
    //   return;
    // }

    const rawUnits = option.units;
    let unitsList = [];
    let selectedUnit = {};
    if (Array.isArray(rawUnits)) {
      unitsList = rawUnits;
      if (rawUnits.length === 1) {
        selectedUnit = rawUnits[0];
      }
    } else if (rawUnits && typeof rawUnits === 'object') {
      selectedUnit = rawUnits;
      unitsList = [rawUnits];
    }

    if (idx === null || idx === undefined) {
      // Update top entry composer
      this.setState({
        entryProduct: option,
        entryUnits: unitsList,
        entryUnit: selectedUnit,
        entryUnitPrice: selectedUnit.total || option.base_price?.total || '',
        entryQty: '',
      }, () => {
        if (this.entryQtyInputRef && this.entryQtyInputRef.current) {
          this.entryQtyInputRef.current.focus();
        }
      });
    } else {
      const row = {...rows[idx]}
      row.unit_price = '';
      row.qty = '';
      row.units = unitsList;
      row.unit = selectedUnit;
      row.unit_price = selectedUnit.total || option.base_price?.total || '';
      row.product = option;
      rows[idx] = row;
      obj_this.setState({
        rows
      });
    }

  }

  entryUnitChange = (option) => {
    if(!option.total){
      alert("Unit price is not added");
      return;
    }
    this.setState({
      entryUnit: option,
      entryUnitPrice: option.total
    });
  }

  entryQtyChange = (e) => {
    const value = e.target.value;
    this.setState({ entryQty: value });
  }

  addEntryToRows = () => {
    if (!this.state.entryProduct.label) {
      alert('Choose product');
      return;
    }
    if (!this.state.entryUnit.label) {
      alert('Choose unit');
      return;
    }
    const qty = parseFloat(this.state.entryQty || '0');
    if (!(qty > 0)) {
      alert('Quantity required');
      return;
    }
    const newItem = {
      product: this.state.entryProduct,
      unit_price: this.state.entryUnitPrice,
      qty: this.state.entryQty,
      units: this.state.entryUnits,
      unit: this.state.entryUnit,
      total: parseFloat(qty * parseFloat(this.state.entryUnitPrice || '0')).toFixed(3)
    };
    const rows = [newItem, ...this.state.rows];
    this.setState({
      rows,
      // reset entry
      entryProduct: {},
      entryUnits: [],
      entryUnit: {},
      entryQty: '',
      entryUnitPrice: ''
    }, () => {
      // minimize older rows and expand the newest one (first after prepend)
      setTimeout(() => {
        const $rows = $(".products_container .single_product_container");
        $rows.slice(1).find(".minimize_button").trigger("click");
        $rows.first().find(".maximize_button").trigger("click");
      }, 0);
      // recalc grand total
      let grand_total = 0;
      for (let i=0;i<rows.length;i++) {
        if (rows[i]['total']) grand_total += parseFloat(rows[i]['total']);
      }
      this.setState({ grand_total: parseFloat(grand_total).toFixed(3) });
    });
    this.closeBilling();
    // Focus back to product entry
    setTimeout(() => {
      if (this.entryProductSelectRef && this.entryProductSelectRef.current && this.entryProductSelectRef.current.focus) {
        this.entryProductSelectRef.current.focus();
      }
    }, 0);
  }

  unitChange(option,idx){
    // console.log(option);
    $(".single_product_container").css('background-color','');
    if(!option.total){
      alert("Unit price is not added");
      return;
    }
    const rows = [...this.state.rows];
    const row = {...rows[idx]};
    row.unit = option;
    row.unit_price = option.total;
    rows[idx] = row;
    this.setState({
      rows
    },() => {
      this.find_total(idx);
    });

  }

  find_total(idx){
    const rows = [...this.state.rows];
    const row = {...rows[idx]};
    const qty =row.qty;
    const unit_price = row.unit_price;
    if(!unit_price){
      return;
    }
    const total = qty*unit_price;
    row.total = parseFloat(total).toFixed(3);
    // console.log(total);
    rows[idx] = row;
    this.setState({
      rows
    });
    var grand_total = 0;
    for(let i=0;i<rows.length;i++){
      if(rows[i]['total']){
        grand_total += parseFloat(rows[i]['total']);
      }
    }

    this.setState({
      grand_total : parseFloat(grand_total).toFixed(3)
    });
  }

  handleChange = idx => e => {
    $(".single_product_container").css('background-color','');
    const { name, value } = e.target;
    const rows = [...this.state.rows];
    const row = {...rows[idx]};
    // if(e.target.name == "qty"){
    //   if(parseFloat(value)> 999){
    //     alert("Enter a value less than 1000")
    //     return;
    //   }
    // }
    row[name] = value;
    rows[idx] = row;
    var obj_this = this;
    this.setState({
      rows
    },() =>{
      if(e.target.name == "qty" ){
        obj_this.find_total(idx)
      }
    });    
  };

  setAction = (action) => {
    this.setState({ action });
  };

  handleAddRow = () => {
    $(".single_product_container").css('background-color','');
    if(!this.validateProducts(this.state.rows)){
      return;
    }
    // console.log(this.state.rows);
    const item = {
      product : {},
      unit_price : '',
      qty: "",
      unit : {}
    };
    this.setState({
      rows: [item, ...this.state.rows]
    }, () => {
      setTimeout(() => {
        const $rows = $(".products_container .single_product_container");
        $rows.slice(1).find(".minimize_button").trigger("click");
        $rows.first().find(".maximize_button").trigger("click");
      }, 0);
    });
    this.closeBilling();
  };

  handleRemoveSpecificRow = (idx) => () => {
    if(!confirm("Are you sure you want to remove this item?")){
      return;
    }
    $(".single_product_container").css('background-color', '');
    const rows = [...this.state.rows];
    rows.splice(idx, 1);
    this.setState({ 
      rows 
    });
    var grand_total = 0;
    for(let i=0;i<rows.length;i++){
      if(rows[i]['total']){
        grand_total += parseFloat(rows[i]['total']);
      }
    }
    this.setState({
      grand_total : parseFloat(grand_total).toFixed(3)
    });

  }

  formSubmit(e){
    e.preventDefault();
    // console.log(this.state);
    // return;
    const { history, location } = this.props;

    if(!this.state.customer.value){
       this.refs.focus();
      return;
    }
    const salesorder = this.state;
    this.isSubmitting = true;
   
    // console.log(this.state);
  //   if(!salesorder.delivery_location.value){
  //     this.locationSelect.current.focus();
  //    return;
  //  }
    //products validation
    if(!this.validateProducts(salesorder.rows)){
      return;
    }
    if(!salesorder.delivery_date){
      alert('Delivery Date cannot be empty');
      return;
    }

    // Custom validation for billing address and contact number
    const billingContactNo = this.state.billing_contact_no;
    const billingAddress = this.state.billing_address;
    const billingPattern = /^(?:\+?\d{1,3})?\d{8}$/;

    // Validate billing address (required)
    if (!billingAddress || billingAddress.trim() === "") {
      if (this.billingDetailsRef.current) {
        if (this.state.billingCollapsed) {
          this.toggleBillingCollapse();
        }
        setTimeout(() => {
          const textarea = this.billingDetailsRef.current.containerRef.current.querySelector('textarea[name="billing_address"]');
          if (textarea) textarea.focus();
        }, 100);
      }
      alert('Please enter a billing address.');
      return;
    }

    // Validate billing contact number (pattern)
    if (billingContactNo && !billingPattern.test(billingContactNo)) {
      if (this.billingDetailsRef.current) {
        if (this.state.billingCollapsed) {
          this.toggleBillingCollapse();
        }
        setTimeout(() => {
          const input = this.billingDetailsRef.current.containerRef.current.querySelector('input[name="billing_contact_no"]');
          if (input) input.focus();
        }, 100);
      }
      alert('Please enter a valid billing contact number.');
      return;
    }

    if(this.state.action=='')
      return;
    
    //product spec unique checking
    if(salesorder.rows.length>1){
      var exist = 0;
      for(var i=0;i<salesorder.rows.length;i++){
        var product = salesorder.rows[i]['product']['value'];
        for(var j=0;j<salesorder.rows.length;j++){
          if(i != j){
            if(salesorder.rows[j]['product']['value'] == product){
              // $(".single_product_container").find(".minimize_button").trigger("click");
              $(".single_product_container[index="+i+"], .single_product_container[index="+j+"]").find(".maximize_button").trigger("click");
              $(".single_product_container[index="+i+"], .single_product_container[index="+j+"]").css('background-color','#ff000063');
              exist = 1;
              // break;
            }
          }
        }
      }
      if(exist){
        alert("Products duplicate exists.");
        return false;
      }
    }
    salesorder.o_date = salesorder.order_date.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' });

    salesorder.d_date = salesorder.delivery_date.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' });
    salesorder.schedule_id = location.state?.schedule_id??'';

    delete salesorder.customers;
    delete salesorder.products;
    salesorder.rows.forEach(clearUnits);

    function clearUnits(item) {
      item.units = [];
    }

    const url = `${process.env.REACT_APP_SSS}/api/saveSalesorder`;
    this.context.loading(1);
    var obj_this = this;
    $.ajax({
      url : url,
      data : {
        sid : this.context.user_details.sid,
        salesorder : salesorder
      },
      type : "POST"
    }).done(function(return_data){
      // console.log(return_data);
      if(return_data.status == "insert"){
        alert("Salesorder successfully inserted");
        localStorage.removeItem(DRAFT_KEY);
        if (location.state && location.state.from == "schedule") {
          history.push("/dayplan/details/edit/"+location.state.schedule_id, { from : "salesorder", salesData:salesorder, purposeOfVisit : location.state.purposeOfVisit });
        } else {
          // Redirect to the previous page if it was called directly
          history.goBack();
        }
      }else if(return_data.status == "update"){
        alert("Salesorder successfully updated");
        localStorage.removeItem(DRAFT_KEY);
        if (location.state && location.state.from == "schedule") {
          history.push("/dayplan/details/edit/"+location.state.schedule_id, { from : "salesorder", salesData:salesorder,  purposeOfVisit : location.state.purposeOfVisit });
        } else {
          // Redirect to the previous page if it was called directly
          history.goBack();
        }
      }else{
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
      // obj_this.props.history.replace('/salesorders');
      obj_this.context.loading(0);
     }).fail(function(){
      alert("Network error");
      obj_this.context.loading(0);
      obj_this.props.history.replace("/");
    });
  }

  handleRefreshCache = () => {
    // Check if any product data is entered
    const hasProductData = this.state.rows.some(row => row.product && (row.product.value || row.product.label));
    if (hasProductData) {
      if (!window.confirm('Do you want to refresh product data?')) {
        return;
      }
    }
    localStorage.removeItem(cacheKey);
    localStorage.removeItem(cacheExpiryKey);
    this.getCustomers();


  }

  validateProducts(products){
    if (!products || products.length === 0) {
      alert('Please add at least one product');
      return false;
    }
    for (var i=0;i<products.length;i++){
      if(products[i].product && products[i].product.label){
        if(!products[i].unit.label){
          alert("Choose unit");
          // $(".single_product_container[index="+i+"]").find(".maximize_button").trigger("click");
          $(".single_product_container[index="+i+"]").find(".unit").focus();
          return false;
        }
        if(products[i].qty<=0){
          alert("Quantity required");
          // $(".single_product_container[index="+i+"]").find(".maximize_button").trigger("click");
          $(".single_product_container[index="+i+"]").find(".product_qty").focus();
          return false;
        }
      }
    }
    return true;
  }

  goBackButton(e){
    e.preventDefault();

    const { history, location } = this.props;

    if (location.state && location.state.from == "schedule") {
      history.push("/dayplan/details/edit/"+location.state.schedule_id, { from : "salesorder",purposeOfVisit : location.state.purposeOfVisit });
    } else {
      // Redirect to the previous page if it was called directly
      history.goBack();
    }
  }

  render(){
    // Reset refs before mapping rows
    this.productRowRefs = [];
    // Ensure delivery_date and order_date are always Date objects
    let deliveryDate = this.state.delivery_date;
    if (typeof deliveryDate === 'string') {
      deliveryDate = new Date(deliveryDate);
    }
    let orderDate = this.state.order_date;
    if (typeof orderDate === 'string') {
      orderDate = new Date(orderDate);
    }
    return (
    <MyContext.Consumer>
      {context => (
        <>
        {this.state.showDraftPopup && (
          <div className="draft-overlay">
            <div className="draft-popup">
              <div className="draft-title">Continue your Draft?</div>
              <div className="draft-message">
                {/* We found an unfinished draft. Would you like to continue where you left off or start a new one? */}
                We found a saved draft. Do you want to continue or start over?
              </div>
              <div className="draft-actions">
                <button className="btn btn-primary" onClick={this.handleDraftRestore}>Continue Draft</button>
                <button className="btn btn-secondary" onClick={this.handleDraftStartNew}>Start Fresh</button>
              </div>
            </div>
          </div>

        )}
        <div className="new_salesorder_container">
          <div className="page_header">
            {/* <span className="back_button" onClick={e=>this.goBackButton(e)}><i className="fas fa-arrow-left"></i></span> */}
            <div className="page_title"><i className="fas fa-arrow-left" onClick={() => window.history.back()} style={{marginRight: '15px', cursor: 'pointer'}}></i> {this.state.salesorder_id ? "Edit" : "New"} Salesorder</div>
            {/* {(!this.state.salesorder_id) && ( */}
              <button
                type="button"
                className="refresh_cache_button"
                style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '1.3em', marginLeft: 'auto' }}
                title="Refresh Customer/Product Cache"
                onClick={this.handleRefreshCache}
              >
                <i className="fa fa-sync-alt"></i>
              </button>
            {/* )} */}
          </div> 
          <form className="sales_order_form"
            onSubmit={e => { this.formSubmit(e); }}
            onKeyDown={this.handleFormKey}
            onKeyDownCapture={this.handleFormKey}
            onKeyPress={this.handleFormKey}
            onKeyUp={this.handleFormKey}
          >
            <div className="tab_nav">
              <button type="button" className={`tab ${this.state.activeTab==='details'?'active':''}`} onClick={() => this.setActiveTab('details')}>Details</button>
              <button type="button" className={`tab ${this.state.activeTab==='products'?'active':''}`} onClick={() => this.setActiveTab('products')}>Products</button>
            </div>
            {this.state.activeTab==='details' && (
            <div className="customer_details_container blocks">
              <div className="input_label">Customer</div>
              <Select 
                options={this.state.customers}  
                value ={this.state.customer}
                className="customer" 
                ref={r => {
                  this.refs = r;
                }}
                onChange={e => this.customerChange(e)}
                required
                isDisabled = { this.state.schedule ? true  :this.state.salesorder_id?true:false}
              />
              {/* <div className="input_label">Order Date</div>
              <DatePicker
                className="input custom_input"
                onChange={(value) => this.onOrderDateChange(value)}
                value={this.state.order_date}
                required
                format="dd-MM-y"
                minDate = {this.state.salesorder_id?"":new Date()}
              /> */}
              <div className="input_label">Delivery Date</div>
              <DatePicker
                className="input custom_input"
                onChange={(value) => this.onDeliveryDateChange(value)}
                value={deliveryDate}
                format="dd-MM-y"
                clearIcon={false}
                minDate = {this.state.salesorder_id?orderDate:new Date()}
              />
              {/* <div className="input_radio_container">
                <span>Payment Type : </span>
                <div className="radio_buttons">
                  {this.state.payment_types.map((item) => (
                    <div className="label_radio_container" key={item.id}>
                      <input type="radio" 
                        name="payment_type" 
                        value={item.id}
                        checked={this.state.payment_type == item.id} 
                        onChange={e => this.paymentTypeChange(e)}
                      />
                      <div className="radio_label">&nbsp;{item.name}</div>&nbsp;&nbsp;&nbsp;
                    </div>
                  ))}
                </div>
              </div> */}
              {/* <div className="input_radio_container">
                <span>Delivery Type : </span>
                <div className="radio_buttons">
                  {this.state.delivery_types.map((item) => (
                    <div className="label_radio_container" key={item.id}>
                      <input type="radio" 
                        name="delivery_type" 
                        value={item.id}
                        checked={this.state.delivery_type == item.id} 
                        onChange={e => this.deliveryTypeChange(e)}
                      />
                      <div className="radio_label">&nbsp;{item.name}</div>&nbsp;&nbsp;&nbsp;
                    </div>
                  ))}
                </div>
              </div> */}
              <div className="input_label">Remarks</div>
              <textarea className="input remarks custom_input" 
                name="remarks"
                value={this.state.remarks}
                onChange={this.formChange}
                autoComplete="off"
              />
            </div>
            )}
            {/*
            <div className="billing_details_container blocks">
              <div className="subtitle">Billing</div>
              <div className="input_label">Address</div>
              <textarea className="input billing_address custom_input" 
                name="billing_address"
                value={this.state.billing_address}
                onChange={this.formChange}
                required
                autoComplete="off"
              />
              <div className="input_label">Contact No</div>
              <input className="billing_contact_no input custom_input"
                type="tel"
                name="billing_contact_no"
                value={this.state.billing_contact_no}
                onChange={this.formChange}
                pattern="^[0]?[1-9][0-9]{9}$"
                // required
                autoComplete="off"
              />
            </div> */}
            {this.state.activeTab==='details' && (
            <BillingDetails
              ref={this.billingDetailsRef}
              billing_address={this.state.billing_address}
              billing_contact_no={this.state.billing_contact_no}
              onChange={this.formChange}
              collapsed ={this.state.billingCollapsed}
              onToggleCollapse={this.toggleBillingCollapse}
              // closeBilling={this.closeBilling}
            />
            )}
            {this.state.activeTab==='details' && (
              <div className="go_products_container">
                <button
                  type="button"
                  className="go_products_button"
                  onClick={() => this.setActiveTab('products')}
                >
                  <i className="fa fa-boxes"></i> Add Products
                </button>
              </div>
            )}
           
            {this.state.activeTab==='products' && (
            <div className="products_container blocks">
              <div className="common_product_entry">
                <div className="product_grid">
                  <div>
                    <div className="input_label">Product</div>
                    <Select 
                      options={this.state.products}  
                      value={this.state.entryProduct}
                      className="product" 
                      ref={this.entryProductSelectRef}
                      onChange={e => this.productChange(e, null)}
                      onMenuOpen={this.openProductsOnFocus}
                      onFocus={this.openProductsOnFocus}
                      openMenuOnFocus
                      placeholder="Select product"
                      filterOption={(option, inputValue) => {
                        if (!inputValue) return true;
                        const words = inputValue.toLowerCase().trim().split(/\s+/);
                        const label = (option.label || '').toLowerCase();
                        return words.every(w => label.includes(w));
                      }}
                    />
                  </div>
                </div>
                <div className="input_grid">
                  <div>
                    <div className="input_label">Unit</div>
                    <Select 
                      options={this.state.entryUnits} 
                      value ={this.state.entryUnit}
                      placeholder=""
                      className="unit react_select" 
                      onChange={this.entryUnitChange}
                      onMenuOpen={this.openProductsOnFocus}
                      onFocus={this.openProductsOnFocus}
                      openMenuOnFocus
                    />
                  </div>
                  <div>
                    <div className="input_label">Quantity</div>
                    <input className="product_qty custom_input"
                      type="number"
                      name="entryQty"
                      step="0.001"
                      min="0"
                      value={this.state.entryQty}
                      onChange={this.entryQtyChange}
                      inputMode="decimal"
                      tabIndex={0}
                      onFocus={this.openProductsOnFocus}
                      autoComplete="off"
                      ref={this.entryQtyInputRef}
                    />
                  </div>
                  <div>
                    <div className="input_label ">UP</div>
                    <input className="selling_price input custom_input"
                      type="number"
                      name="entryUnitPrice"
                      value={this.state.entryUnitPrice}
                      min="0"
                      step="0.001"
                      autoComplete="off"
                      disabled
                      onFocus={this.openProductsOnFocus}
                    />
                  </div>
                  <div className="add_entry_button_col">
                    <div className="input_label">&nbsp;</div>
                    <button
                      type="button"
                      className="add_product_button"
                      onClick={this.addEntryToRows}
                      disabled={!this.state.entryProduct.label || !this.state.entryUnit.label || !(parseFloat(this.state.entryQty||'0')>0)}
                    >
                      <i className="fa fa-plus"></i> Add
                    </button>
                  </div>
                </div>
              </div>
              {this.state.rows.map((item, idx) => (
                <div
                  className="single_product_container"
                  key={idx}
                  index={idx}
                  ref={el => this.productRowRefs[idx] = el}
                >
                  <div className="product_label_and_delete_button">
                    <div className="maximize_button">
                      <i className="fa fa-plus"></i>
                    </div>
                    <div className="minimize_button">
                      <i className="fa fa-minus"></i>
                    </div>
                    <div className="product_label">
                        {this.state.rows[idx].product.label}
                    </div>
                    <i className="delete_product_button fa fa-trash-alt" 
                      type="button"
                      style={{visibility:this.state.rows.length >1?"visible":"hidden"}}
                      onClick={this.handleRemoveSpecificRow(idx)}
                    ></i>
                  </div>
                  <div className="qty_unit_price_container">
                    <span
                       style={{visibility:this.state.rows[idx].unit.label?"visible":"hidden"}}
                    >Q : {this.state.rows[idx].qty} {this.state.rows[idx].unit.label}</span>
                    <span
                       style={{visibility:this.state.rows[idx].unit_price?"visible":"hidden"}}
                    >UP : {this.state.rows[idx].unit_price}  {this.context.currency} </span>
                    <div 
                      style={{visibility:this.state.rows[idx].total?"visible":"hidden"}}
                      className="product_total"
                    >Total: {this.context.currency}.
                      <span>{this.state.rows[idx].total}</span>
                      </div>
                      </div>
                      <div className="product_grid">
                        <div>
                          <div className="input_label">Product</div>
                          <Select 
                            options={this.state.products}  
                            value={this.state.rows[idx].product}
                            className="product" 
                            onChange={e => this.productChange(e,idx)}
                            required
                            filterOption={(option, inputValue) => {
                              if (!inputValue) return true;
                              const words = inputValue.toLowerCase().trim().split(/\s+/);
                              const label = (option.label || '').toLowerCase();
                              return words.every(w => label.includes(w));
                            }}
                            onFocus={() => {
                              if (this.state.activeTab !== 'products') this.setActiveTab('products');
                              try {
                                const $container = $(this.productRowRefs[idx]);
                                const $maxBtn = $container.find('.maximize_button');
                                if ($maxBtn && $maxBtn.is(':visible')) { $maxBtn.trigger('click'); }
                              } catch (_) {}
                            }}
                            openMenuOnFocus
                            onMenuOpen={() => {
                              setTimeout(() => {
                                if (this.productRowRefs[idx]) {
                                  this.productRowRefs[idx].scrollIntoView({ behavior: 'smooth', block: 'start' });
                                  // const input = this.productRowRefs[idx].querySelector('.product');
                                  // if (input) input.focus();
                                }
                                // Open Products tab and expand the current row when interacting with product select
                                if (this.state.activeTab !== 'products') this.setActiveTab('products');
                                try {
                                  const $container = $(this.productRowRefs[idx]);
                                  const $maxBtn = $container.find('.maximize_button');
                                  if ($maxBtn && $maxBtn.is(':visible')) { $maxBtn.trigger('click'); }
                                } catch (_) {}
                              }, 400);
                            }}
                          />
                        </div>
                      </div>
                      <div className="input_grid">
                       
                    <div>
                      <div className="input_label">Unit</div>
                      <Select 
                        options={this.state.rows[idx].units} 
                        value ={this.state.rows[idx].unit}
                        placeholder="" 
                        className="unit react_select" 
                        onChange={e => this.unitChange(e,idx)}
                        required
                        onFocus={() => {
                          if (this.state.activeTab !== 'products') this.setActiveTab('products');
                          try {
                            const $container = $(this.productRowRefs[idx]);
                            const $maxBtn = $container.find('.maximize_button');
                            if ($maxBtn && $maxBtn.is(':visible')) { $maxBtn.trigger('click'); }
                          } catch (_) {}
                        }}
                        openMenuOnFocus
                        onMenuOpen={() => {
                          if (this.state.activeTab !== 'products') this.setActiveTab('products');
                          try {
                            const $container = $(this.productRowRefs[idx]);
                            const $maxBtn = $container.find('.maximize_button');
                            if ($maxBtn && $maxBtn.is(':visible')) { $maxBtn.trigger('click'); }
                          } catch (_) {}
                        }}
                        // isDisabled={true} 
                      />
                    </div>
                    <div>
                      <div className="input_label">Quantity</div>
                      <input className="product_qty custom_input"
                        type="number"
                        name="qty"
                        step="0.001"
                        min="0"
                        // max="999"
                        value={this.state.rows[idx].qty}
                        onChange={this.handleChange(idx)}
                        onFocus={(e) => { if (this.state.activeTab !== 'products') this.setActiveTab('products'); this.expandRowOnFocus(e); }}
                        inputMode="decimal"
                        tabIndex={0}
                        autoComplete="off"
                      />
                    </div>
                    <div>
                    <div className="input_label ">UP</div>
                    <input className="selling_price input custom_input"
                      type="number"
                      name="unit_price"
                      value={this.state.rows[idx].unit_price}
                      onChange={this.handleChange(idx)}
                      min="0"
                      step="0.001"
                      autoComplete="off"
                      disabled
                    />                   
                    </div>
                    <div className="stock_container">
                      <div className="input_label">Stock</div>
                      <input className="selling_price input custom_input"
                        type="number"
                        name="stock_quantity"
                        value={this.state.rows[idx].product?.stock??this.state.rows[idx].stock}
                        // onChange={this.handleChange(idx)}
                        // min="0"
                        // step="0.001"
                        autoComplete="off"
                        disabled
                      />       
                      {/* <span className="stock_quantity input custom_input" >{this.state.rows[idx].product?.stock}</span> */}
                    </div>
                 </div>      
              </div>
              ))}
              <div className="price_and_add_button_container">
                <div className="grand_total"
                  style={{visibility:this.state.grand_total?"visible":"hidden"}}
                >Total ({this.state.rows.length}) {this.context.currency}.
                  <b> {this.state.grand_total}</b>
                  </div>
              </div>
            </div>
            )}
            {/* {this.state.activeTab==='details' && (

            <div className="delivery_details_container blocks"
            style={{display:this.state.file != null && this.state.file != '' ?"block":"none"}}

            >
              <div className="delivery_title_container">
                <div className="subtitle">File Upload</div>
              </div>
              <div className="input_label">{this.state.file}</div>
            </div>
            )} */}
            {/* <button type="submit" className="submit_button"><i className="far fa-save"></i> Save</button> */}
            {/* <div className="spacer"></div> */}
            {this.state.activeTab==='products' && (

            <div className="button-container">
              <button type="button" value="draft" onClick={() => this.setState({ action: 'draft' }, () => this.formSubmit({ preventDefault: () => {} }))} className="submit_button draft-button"><i className="far fa-save"></i> Draft</button>
              <button type="button" value="confirm" onClick={() => { if(!confirm("Are you sure you want to confirm this order?")) return; this.setState({ action: 'confirm' }, () => this.formSubmit({ preventDefault: () => {} })); }} className="submit_button"><i className="far fa-save"></i> Confirm</button>
            </div>
            )}
            {/* <div className="spacer"></div> */}
          </form>           
        </div>
        </>
      )}
    </MyContext.Consumer>
  )}
}

export default NewOrder;
NewOrder.contextType = MyContext;
